import { Component, Listen, QueryAll } from '@atomify/core';

const TAB_ATTRIBUTE = 'tab';

@Component({
    tag: 'bpd-downloads',
})
export class BPDDownloads extends HTMLElement {
    @QueryAll('[js-hook-downloads-tab]') downloadsTabs: Array<HTMLElement>;
    @QueryAll('[js-hook-downloads]') downloads: Array<HTMLElement>;
    @QueryAll('[js-hook-downloads-documents]') documents: Array<HTMLElement>;

    componentWillRender() {
        this.downloadsTabs[0]?.setAttribute('selected', '');

        this.documents.forEach((document: HTMLElement) => {
            const tabIndex = document.getAttribute(TAB_ATTRIBUTE);

            if (tabIndex && tabIndex != '1') {
                document.style.display = 'none';
            }
        });

        this.documents[0].style.display = 'block';
    }

    hideNonIndexDocuments(tabIndex: string) {
        this.documents.forEach((element: HTMLElement) => {
            if (element.getAttribute(TAB_ATTRIBUTE) != tabIndex) {
                element.style.display = 'none';
            }
        });
    }

    toggleSelectedTab(tabIndex: string) {
        this.downloadsTabs.forEach((tab: HTMLElement) => {
            if (tab.getAttribute(TAB_ATTRIBUTE) != tabIndex) {
                tab.removeAttribute('selected');
            }
        });
    }

    @Listen('click', { target: 'downloadsTabs' })
    handleTabClick(e: any) {
        e.preventDefault();
        const { currentTarget } = e;

        const tabIndex = currentTarget.getAttribute(TAB_ATTRIBUTE);

        this.documents.forEach((element: HTMLElement) => {
            if (element.getAttribute('tab') === tabIndex) {
                element.style.display = 'block';

                currentTarget.setAttribute('selected', '');
                this.hideNonIndexDocuments(tabIndex);
                this.toggleSelectedTab(tabIndex);
            }
        });
    }
}
